import { chain } from 'lodash';
import { ActionType } from '../../classes/package-listing-actions';
import { IEventFilter, IPerformanceErrorMessage, ISpecialFeatureMapValue, PackageType } from '../../classes/package-listing';
import { IPackage, IPerformance, IPerformancePricing, IPackagePricing, IPackageRequest } from '../../custom/classes/production';
import { IPackageListingAppState } from '..';
import { getPerformancePricing, getPackagePricing, getFlexPackagePricingForPerfs } from './package-api.actions';
import cartItem from '../../components/cart/cart-item';

/**
 * Use only after events have been updated.
 */
export function eventsUpdated() {
    return {
        type: ActionType.PerformancesUpdated
    }
}

/**
 * Update the events being stored in the redux state.
 * @param events
 */
//export function updateEvents(performanceGroups: Array<IPerformanceGroup>) {
//    return {
//        type: ActionType.UpdateEvents,
//        value: performanceGroups
//    }
//}


export function loadPackage(packageDetail: IPackage) {
    return {
        type: ActionType.LoadPackage,
        value: packageDetail
    }
}

export function loadPackages(packages: Array<IPackage>) {
    return {
        type: ActionType.LoadPackages,
        value: packages
    }
}

export function loadPackageRequest(packageDetail: IPackageRequest) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        dispatch(
            {
                type: ActionType.LoadPackageRequest,
                value: {
                    currentRenewalPackageId: packageDetail.packageId
                }
            }
        );

        chain(packageDetail.requestedPriceTypeIds)
            .groupBy(id => id)
            .forEach((priceTypes, ptId) => {
                dispatch(updatePriceTypeQuantity(+ptId, priceTypes.length));
            })
            .value();


        if (packageDetail.packageId > 0) {
            const currentState = getState();
            const selectedPackage = currentState.packageListing.packages.filter(pkg => pkg.id == packageDetail.packageId)[0];
            if (selectedPackage) {
                dispatch(selectPackage(
                    selectedPackage, true,
                    selectedPackage.useUnseatedReservation
                    || currentState.packageListingSettings.isRenewal));

                if (packageDetail.secondChoicePackageId > 0) {
                    const selectedSecondChoicePackage = currentState.packageListing.packages
                        .filter(pkg => pkg.id == packageDetail.secondChoicePackageId)[0];
                    if (selectedSecondChoicePackage) {
                        dispatch(selectPackage(
                            selectedSecondChoicePackage, true,
                            selectedSecondChoicePackage.useUnseatedReservation
                            || currentState.packageListingSettings.isRenewal));
                    }
                }
            }
        }

        if (packageDetail.subPackageZones) {
            for (let subPackageId in packageDetail.subPackageZones) {
                let zoneId = packageDetail.subPackageZones[subPackageId];
                dispatch(updateSelectedZone(+subPackageId, zoneId, false));
            }
        } else if (packageDetail.zoneId > 0) {
            dispatch(updateSelectedZone(packageDetail.packageId, packageDetail.zoneId, false));
            if (packageDetail.secondChoiceZoneId > 0) {
                if (packageDetail.packageId === packageDetail.secondChoicePackageId
                    || packageDetail.secondChoicePackageId === 0) {
                    dispatch(toggleAlternateRequestType(packageDetail.packageId));
                }

                dispatch(updateSelectedZone(packageDetail.packageId, packageDetail.secondChoiceZoneId, true));
            }
        }
    }
}

export function upsertEventFilter(filterFunction: IEventFilter) {
    return {
        type: ActionType.UpdatePerformancesFilter,
        value: filterFunction
    }
}

export function removeEventFilter(filterKey: string) {
    return {
        type: ActionType.RemovePerformancesFilter,
        value: filterKey
    }
}

export function removeAllEventFilters() {
    return {
        type: ActionType.RemoveAllPerformancesFilters
    }
}

export function updateSettings(settings) {
    return {
        type: ActionType.UpdateSettings,
        value: settings
    }
}

export function selectPerformance(performance: IPerformance, unseated: boolean) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        dispatch(addItemToCart(performance.performanceId, false, null, unseated));
        if (unseated) {
            let state = getState();
            let cartItems = state.packageListing.cartItems;
            if (cartItems.length >= state.packageListing.packageDetail.minimumPerformances) {
                var perfList = "";
                for (var i = 0; i < cartItems.length; i++) {

                    if (i == cartItems.length - 1) {
                        perfList = perfList + cartItems[i].cartItemId.toString();
                    } else {
                        perfList = perfList + cartItems[i].cartItemId.toString() + ',';
                    }

                }
                if (state.packageListing.priceTypeQuantity.size > 0) {
                    var priceType = [...state.packageListing.priceTypeQuantity][0][0];
                    var quantity = [...state.packageListing.priceTypeQuantity][0][1];
                    if (quantity > 0) {
                        dispatch(getFlexPackagePricingForPerfs(perfList, quantity, priceType));
                    }
                    
                }
                
            }
        } else {
            dispatch(getPerformancePricing(performance.performanceId));
        }
    }
}

export function getUnseatedFlexPricingFromPt(quantity: number, priceTypeId: number) {
    return (dispatch, getState: () => IPackageListingAppState) => {
        let state = getState();
        if (state.packageListing.packageDetail !== null && state.packageListing.packageDetail.packageType !== null) {
            if (state.packageListing.packageDetail.packageType == PackageType.Flex && state.packageListing.packageDetail.useUnseatedReservation) {
                var cartItems = state.packageListing.cartItems;
                if (cartItems.length >= state.packageListing.packageDetail.minimumPerformances) {
                    var perfList = "";
                    for (var i = 0; i < cartItems.length; i++) {

                        if (i == cartItems.length - 1) {
                            perfList = perfList + cartItems[i].cartItemId.toString();
                        } else {
                            perfList = perfList + cartItems[i].cartItemId.toString() + ',';
                        }

                    }
                    if (quantity > 0) {
                        dispatch(getFlexPackagePricingForPerfs(perfList, quantity, priceTypeId));
                    }
                }
            }
        }
    }
}

export function selectPackage(pkg: IPackage, isFixed: boolean, unseated: boolean) {
    return (dispatch, getState: () => IPackageListingAppState) => {

        // super package
        if (pkg.subPackages.length > 0) {
            pkg.subPackages.forEach(subPackage => {
                dispatch(addItemToCart(subPackage.id, false, pkg.id, unseated));
            });
        } else {
            dispatch(addItemToCart(pkg.id, isFixed, undefined, unseated));
        }
        dispatch(getPackagePricing(pkg.id));

    }
}

export function receivePerformancePricing(performancePricing: Array<IPerformancePricing>) {
    return {
        type: ActionType.ReceivePerformancePricing,
        value: performancePricing
    }
}

export function receivePackagePricing(packagePricing: IPackagePricing) {
    return {
        type: ActionType.ReceivePackagePricing,
        value: packagePricing
    }
}

export function addItemToCart(itemId: number, isFixed: boolean, parentPackageId: number = undefined, unseated: boolean = undefined) {
    return {
        type: ActionType.AddItemToCart,
        value: {
            itemId,
            isFixed,
            packageId: parentPackageId,
            unseated
        }
    }
}

export function removeItemFromCart(itemId: number, isAlternate?: boolean) {
    return {
        type: ActionType.RemoveItemFromCart,
        value: {
            itemId,
            isAlternate
        }
    }
}

export function updateSelectedZone(itemId: number, zoneId: number, isSecondChoice: boolean) {
    return {
        type: ActionType.UpdateSelectedZone,
        value: {
            itemId: itemId,
            zoneId: zoneId,
            isSecondChoice: isSecondChoice
        }
    }
}

export function removeSelectedZone(cartItemId: number) {
    return {
        type: ActionType.RemoveSelectedZone,
        value: cartItemId
    }
}

export function updatePriceTypeQuantity(priceTypeId: number, quantity: number) {
    return {
        type: ActionType.UpdatePriceTypeQuantity,
        value: {
            priceTypeId: priceTypeId,
            quantity: quantity
        }
    }
}


export function clearPriceTypeQuantities() {
    return {
        type: ActionType.ClearPriceTypeQuantities,
        value: {
        }
    }
}

export function updateOrderNotes(orderNotes: string) {
    return {
        type: ActionType.UpdateOrderNotes,
        value: orderNotes
    }
}

export function updateSeatingPreferences(preferences: string) {
    return {
        type: ActionType.UpdateSeatingPreferences,
        value: preferences
    }
}

export function processPackageRequest() {
    return {
        type: ActionType.UpdatePackageProcessing,
        value: true
    }
}


export function processPackageRequestError(errorMessages: Array<IPerformanceErrorMessage>) {
    return {
        type: ActionType.UpdatePackageProcessingErrors,
        value: errorMessages
    }
}

export function toggleMiniCart(openMiniCart: boolean) {
    return {
        type: ActionType.ToggleMiniCart,
        value: openMiniCart
    }
}

export function setSpecialFeatureMap(map: Map<string, ISpecialFeatureMapValue>) {
    return {
        type: ActionType.SetSpecialFeatureMap,
        value: map,
    }
}

export function toggleAlternateRequestType(itemId: number) {
    return {
        type: ActionType.ToggleAlternateRequestType,
        value: itemId,
    }
}

export function disablePerformanceButtons(disableButtons: boolean) {
    return {
        type: ActionType.DisablePerformanceButtons,
        value: disableButtons
    }
}